import React from "react";
import { StyledList } from "../style/support.style";
import SupCard from "./SupCard.component";
import cardsArray from "../content/supportArticles";

const SupportCards = () => {
  const displayCards = () => {
    return cardsArray.map((card, index) => {
      return (
        <li>
          <SupCard card={card} key={index}/>
        </li>
      );
    });
  };
  return <StyledList>{displayCards()}</StyledList>;
};
export default SupportCards;
